import React, { Component } from 'react';
import { addAnimation } from '../Common/common';

export default class Dropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDisplayList: false,
			list: this.props.list,
			options: this.updateOptions(this.props.list),
			is_toggle_dropdown: this.props.is_toggle_dropdown,
		}

		this.setWrapperRef = this.setWrapperRef.bind(this);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleOnClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleOnClickOutside);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.list != nextState.list) {
			this.setState({
				list: nextProps.list,
				options: this.updateOptions(nextProps.list),
			})

			return true;
		}

		if (nextProps.is_toggle_dropdown != nextState.is_toggle_dropdown) {
			this.setState({
				isDisplayList: !this.state.isDisplayList,
				is_toggle_dropdown: nextProps.is_toggle_dropdown,
			})

			return true;
		}

		if (nextProps.header != this.props.header) {
			return true;
		}

		if (this.state.isDisplayList != nextState.isDisplayList) {
			return true;
		}
		return true;
	}

	updateOptions(list) {
		let options = [];

		let liStyle = {
			fontFamily: 'Myriad-light',
			textAlign: 'center',
			cursor: 'pointer',
			listStyle: 'none',
			fontFamily: 'Arial',
			color: '#5a5a5a',
			padding: 6,
			':hover': {
				opacity: 0.7,
				backgroundColor: '#cac9c9',
			},
		}

		let liHeaderStyle = {
			fontFamily: 'Myriad-light',
			fontSize: 18,
			background: 'gray',
			textAlign: 'center',
			cursor: 'pointer',
			listStyle: 'none',
			fontFamily: 'Arial',
			color: 'white',
			marginLeft: -10,
			padding: 6,
			width: '110%',
		}

		liStyle = Object.assign(liStyle, this.props.liStyle);
		liHeaderStyle = Object.assign(liHeaderStyle, this.props.liHeaderStyle);

		for (let i in list) {
			if (list[i].is_header != null && list[i].is_header == true) {
				options.push(
					<li
						key={list[i].value}
						value={list[i].value}
						style={liHeaderStyle}>{list[i].display}</li>);
			} else {
				options.push(
					<li
						key={list[i].value}
						value={list[i].value}
						style={liStyle}
						onClick={(event) => this.handleOnClick(list[i].value)}
						onTouchMove={(event) => this.handleOnMouseMove(list[i].value)}>{list[i].display}</li>);
			}
		}

		return options
	}

	handleOnClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({ isDisplayList: false });
		}
	}

	handleOnClick = (val) => {
		this.props.handleListOnClick(val);
		this.handleToggleList();
	}

	handleOnMouseMove = (event) => {
		this.setState({ isDisplayList: false })
		this.props.handeListOnMove(event);
	}

	handleToggleList = () => {
		let element = document.getElementById('dropdown_header_' + this.props.id);
		addAnimation(element, 'fadeIn', () => { }, 300);
		this.setState({
			isDisplayList: !this.state.isDisplayList,
		})
	}

	/**
	* Set the wrapper ref
	*/
	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	render() {
		let style = {
			cursor: 'pointer'
		}

		let dropdown_style = {
			display: this.state.isDisplayList && this.state.options.length > 0 ? 'block' : 'none',
			position: 'absolute',
			backgroundColor: 'white',
			borderRadius: '4px',
			boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2)',
			overflow: 'auto',
			maxHeight: 250,
			zIndex: 1,
		};

		let ul_style = {
			fontFamily: 'Myriad-light',
			padding: 10,
			margin: 0
		}

		let header_style = {
			fontFamily: 'Myriad-light',
			fontSize: 24,
			color: '#707070',
			borderBottom: '1px solid gray',
		}

		style = Object.assign(style, this.props.style);
		dropdown_style = Object.assign(dropdown_style, this.props.dropdown_style);
		header_style = Object.assign(header_style, this.props.header_style);

		return (
			<div style={style} ref={this.setWrapperRef}>
				<div onClick={this.handleToggleList} style={{ width: '100%' }}>
					<span id={'dropdown_header_' + this.props.id} style={header_style} >{this.props.header}</span>
				</div>
				<div className='noScrollBar' style={dropdown_style}>
					<ul style={ul_style}>
						{this.state.options}
					</ul>
				</div>
			</div>
		)
	}


}